export default __webpack_public_path__ + "static/media/82_mobile.fbe2cc61.jpg";